import { MagnifyingGlassIcon } from "@heroicons/react/24/outline"
import { Input, Radio } from "antd"

const FILTER_CHIP_BASE =
  "text-slate-900 text-xs border p-2 w-fit rounded-md [&_.ant-radio-inner]:border-slate-400 [&_.ant-radio-checked_.ant-radio-inner]:bg-slate-900 [&_.ant-radio-checked_.ant-radio-inner]:border-slate-900"

const chipClassName = (isSelected: boolean) =>
  `${FILTER_CHIP_BASE} ${isSelected ? "border-slate-900" : "border-[#E2E8F0]"}`

const WorkPlaceFilterWrapper = ({
  setInputValue,
  debouncedSetSearch,
  inputValue,
  selectedFilter,
  setSelectedFilter,
  totalDocs,
  publishedCount,
  inactiveCount,
  draftsCount,
}: {
  debouncedSetSearch: (value: string) => void
  setInputValue: (value: string) => void
  inputValue: string
  selectedFilter: string
  setSelectedFilter: (value: string) => void
  totalDocs: number
  publishedCount: number
  inactiveCount: number
  draftsCount: number
}) => {
  return (
    <div className="flex flex-wrap items-center justify-between pt-6">
      <h5 className="text-lg font-bold ">Workplaces</h5>
      <div className="flex flex-wrap items-center gap-2">
        <Input
          placeholder="Search for a workplace"
          onChange={(e) => {
            const value = e.target.value
            setInputValue(value)
            debouncedSetSearch(value)
          }}
          value={inputValue}
          style={{ width: "262px", height: "40px" }}
          prefix={<MagnifyingGlassIcon className="w-4 h-4 text-neutral-300" />}
        />
        <div className="border border-[#E2E8F0] h-6"></div>
        <Radio.Group
          value={selectedFilter}
          onChange={(e) => setSelectedFilter(e.target.value)}
          style={{ display: "flex", alignItems: "center" }}
        >
          <Radio
            value="all"
            className={chipClassName(selectedFilter === "all")}
            style={{ display: "flex", alignItems: "center" }}
          >
            <span>All</span> <span>[{totalDocs || 0}]</span>
          </Radio>
          <Radio
            value="published"
            className={chipClassName(selectedFilter === "published")}
            style={{ display: "flex", alignItems: "center" }}
          >
            <span>Published</span> <span>[{publishedCount}]</span>
          </Radio>
          <Radio
            value="inactive"
            disabled
            className={chipClassName(selectedFilter === "inactive")}
            style={{ display: "flex", alignItems: "center" }}
          >
            <span>Inactive</span> <span>[0]</span>
          </Radio>
          <Radio
            value="draft"
            className={chipClassName(selectedFilter === "draft")}
            style={{ display: "flex", alignItems: "center" }}
          >
            <span>Drafts</span> <span>[{draftsCount}]</span>
          </Radio>
        </Radio.Group>
      </div>
    </div>
  )
}
export default WorkPlaceFilterWrapper
